<template>
    <div class="faq-wrapper">
        <Head :title="$tc('header.back')"/>
        <div class="faq-inner" v-if="questionsData">
            <h4 class="page-title">
                <span>{{$tc('faq.faq')}}</span>
            </h4>
            <div class="nav" :class="[showAll && 'show-all']">
                <button class="toggle-btn" v-if="questionsData.length > 6" @click="toggleCate"><i class="iconfont iconshuangjiantou-xia"></i></button>
                <span :class="[curIndex == index && 'active']" v-show="index < 6 || showAll" @click="changeCate(index)" v-for="(item, index) in questionsData" :key="index">{{item.name}}<b v-if="item.label === 1">HOT</b></span>
            </div>
            <div class="faq-cate-wrapper" v-for="(qusItem, qusIndex) in questionsData" :key="qusIndex" v-show="qusIndex === curIndex">
                <h4 class="faq-cate-title">
                    <span>{{qusItem.name}}</span>
                </h4>
                <div class="faq-list" v-if="qusItem.questions">
                    <div class="faq-item" v-for="(item, index) in qusItem.questions" :key="index">
                        <h3 class="faq-item-title">{{item.name}}<i @click="toggleItem(item.id, $event)" class="iconfont iconxiajiantou_huaban"></i></h3>
                        <div class="content" v-html="item.content"></div>
                    </div>
                </div>
                <Empty :emptydata="{type: 'nodata'}" v-else/>
            </div>
        </div>
        <Empty :emptydata="emptydata" v-if="emptydata"/>
    </div>
</template>

<script>

import { mapMutations } from 'vuex'

export default {
    name: 'FAQ',
    data () {
        return {
            questionsData: null,
            showAll: false,
            curIndex: 0,
            emptydata: null
        }
    },
    created () {
        this.getChannelData()
    },
    mounted () {
        this.$nextTick(() => {
            this.$Common.pageShare()
        })
        this.$Common.track('load', {
            name: '常见问题页',
            type: '资讯'
        })
    },
    methods: {
        ...mapMutations(['setShowLoading']),
        getChannelData () {
            this.$Api.getQuestionList({}).then(data => {
                if (data && data.categoryQuestions && data.categoryQuestions.length) {
                    this.questionsData = data.categoryQuestions
                } else {
                    this.emptydata = {
                        type: 'nodata'
                    }
                }
                this.setShowLoading(false)
            }).catch(() => {
                this.emptydata = {
                    type: 'nonetwork'
                }
                this.setShowLoading(false)
            })
        },
        changeCate (index) {
            this.curIndex = index
        },
        toggleCate () {
            this.showAll = !this.showAll
        },
        toggleItem (id, e) {
            const parent = e.target.parentNode.parentNode
            const className = parent.className
            if (className.indexOf('open') > -1) {
                parent.className = className.split(' open')[0]
            } else {
                parent.className = `${className} open`
            }
            this.$Api.questionClick({
                questionId: id
            })
        }
    }
}
</script>

<style lang="scss">
    .faq-wrapper {
        font-size: 0;
        padding-bottom: 13.889vw;
        .faq-inner {
            .empty-wrapper {
                height: auto;
            }
        }
        .nav {
            padding: 0 0 0 1.574vw;
            border-bottom: none;
            position: relative;
            z-index: 2;
            &::after {
                content: '';
                height: 0;
                width: 92.778vw;
                position: absolute;
                bottom: 0;
                left: 3.611vw;
                border-bottom: 1px solid #ECF2F5;
            }
            span {
                font-size: 3.981vw;
                padding: 0.9vw 9.259vw;
                margin: 0 2.037vw 5.741vw;
                font-weight: normal;
                border-radius: 3.704vw;
                min-width: 28.241vw;
                justify-content: center;
                position: relative;
                b {
                    font-weight: normal;
                    font-size: 2.407vw;
                    position: absolute;
                    right: 1.852vw;
                    top: 50%;
                    transform: translateY(-50%);
                }
            }
        }
        .faq-cate-title {
            color: #898989;
            font-size: 4.63vw;
            border-bottom: 1px solid #ECF2F5;
            margin: 7.407vw 3.611vw 0;
            line-height: 1.4;
            padding-bottom: 1.667vw;
            word-wrap: break-word;
        }
        .faq-item {
            padding: 4.63vw 3.611vw 0;
            margin-bottom: 2.778vw;
            .faq-item-title {
                font-size: 4.259vw;
                color: #000;
                line-height: 1.4;
                margin-bottom: 4.815vw;
                word-wrap: break-word;
                i {
                    font-size: 5vw;
                    font-weight: normal;
                    color: #8794ab;
                    margin-left: 2.778vw;
                    display: inline-block;
                    vertical-align: middle;
                    transition: all .3s;
                }
            }
            .content {
                font-size: 16px;
                display: none;
                overflow: hidden;
                img {
                    max-width: 100%;
                    width: auto;
                }
            }
            &.open {
                .faq-item-title {
                    i {
                        transform: rotate(180deg);
                    }
                }
                .content {
                    display: block;
                }
            }
        }
    }
</style>
